import React from 'react';

import { Modal } from '@shared/components/bootstrap';

import { Spinner } from '@admin/components/spinner';
import { client } from '@admin/libraries/apollo';
import { useAdminTeamQuery } from '@admin/schema';

import {
  ErrorText,
  initialsForName,
  MemberAvatar,
  MemberList,
  MemberName,
  MemberRow,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalShell,
  ModalSubtitle,
  ModalTitle,
  MutedText,
  SecondaryButton,
} from './teams_styles';

export const MembersModal: React.FC<{
  teamId: string;
  teamName: string;
  memberCount: number;
  onClose(): void;
}> = ({ teamId, teamName, memberCount, onClose }) => {
  const { data, loading, error } = useAdminTeamQuery({
    client,
    variables: { id: teamId },
  });

  const members = data?.adminTeam?.users ?? [];

  return (
    <Modal onClose={onClose}>
      <ModalShell className="modal-content">
        <ModalHeader>
          <ModalTitle>{teamName}</ModalTitle>
          <ModalSubtitle>
            {loading
              ? 'Loading members…'
              : `${members.length || memberCount} active ${members.length === 1 ? 'member' : 'members'}`}
          </ModalSubtitle>
        </ModalHeader>
        <ModalBody>
          {error && <ErrorText>Failed to load team members. Please try again.</ErrorText>}
          {loading ? (
            <Spinner />
          ) : members.length === 0 ? (
            <MutedText>No active members on this team.</MutedText>
          ) : (
            <MemberList>
              {members.map((member) => (
                <MemberRow key={member.id} href={`/users/${member.id}`}>
                  <MemberAvatar>{initialsForName(member.name)}</MemberAvatar>
                  <MemberName>{member.name}</MemberName>
                </MemberRow>
              ))}
            </MemberList>
          )}
        </ModalBody>
        <ModalFooter>
          <SecondaryButton type="button" onClick={onClose}>
            Close
          </SecondaryButton>
        </ModalFooter>
      </ModalShell>
    </Modal>
  );
};
